<div *ngIf="data$ | async as data" class="flex flex-col flex-grow w-full md:flex-row md:px-4">
  <div class="flex flex-col-reverse flex-grow justify-end px-4 pt-5 md:pl-0 lg:flex-row md:pt-6">
    <ng-container *ngIf="valuePropositionVisible">
      <app-value-proposition-vertical
        class="hidden mr-4 lg:block xl:mr-8"
        [highlight]="appHover || data.isAppSelected"
      ></app-value-proposition-vertical>
    </ng-container>

    <app-payment-method
      class="lg:flex-grow"
      [email]="payment.email"
      [totalAmount]="payment.totalAmount"
      [paymentMethodControl]="form.paymentMethod"
      [availablePaymentMethods]="availablePaymentMethods"
      [availableBillGatewayApps]="availableBillGatewayApps"
      [noCommissionLabelEnabled]="payment.commission > 0"
      (appHover)="appHover = $event"
    ></app-payment-method>
  </div>

  <app-summary
    [personalDataForm]="form.personalData"
    [imojeTosControl]="form.imojeTos"
    [imojeTosVisible]="imojeTosVisible$ | async"
    [submitReady]="submitReady$ | async"
    [submitted]="submitted"
    [paymentSummary]="data.paymentSummary"
    [brand]="brand"
    (formSubmitted)="onSubmit()"
  ></app-summary>

  <div class="sticky bottom-0 z-40 md:hidden">
    <app-floating-submit
      [paymentSummary]="data.paymentSummary"
      [submitReady]="submitReady$ | async"
      [submitted]="submitted"
      (formSubmitted)="onSubmit()"
    ></app-floating-submit>
  </div>

  <div class="px-5 pb-4 text-sm text-gray-700 bg-white md:text-xs md:hidden">
    Kliknięcie w przycisk oznacza zapoznanie się się i akceptację
    <a class="underline" [href]="brand.termsOfUseLink">Regulaminu</a> oraz
    <a class="underline" [href]="brand.privacyPolicyLink">Polityki Prywatności</a>.
  </div>
</div>
